export default {
  standings: {
    title: "Classificação",
    empty: {
      unavailable: "Classificação indisponível no momento.",
    },
    labels: {
      ranking: "#",
      team: "Equipe",
    },
    columns: {
      GP: "GP",
      W: "W",
      L: "L",
      T: "T",
      OTL: "OTL",
      PTS: "PTS",
      PCT: "PCT",
      D: "D",
    },
    picker: {
      conference: "Conferência",
      division: "Divisão",
      overall: "Geral",
    },
    sections: {
      conference: "Conferência",
      division: "Divisão",
      overall: "Geral",
    },
  },
};